import { createSelector } from 'reselect';

const getActiveTeamTab = (state) => {
    const {
        gumbo : {
            gameData: {
                game: {
                    pk
                } = {}
            } = {},
            liveData: {
                linescore = {},
                boxscore = {}
            } = {},
        }= {}
    } = state || {};

    const isHomeBatting = linescore?.offense?.team?.id === boxscore?.teams?.home?.team?.id;

    return {
        isHomeBatting,
        inningHalf: linescore?.inningHalf,
        gamePk: pk
    }

};

export const getActiveTeamTabState = createSelector(
    [getActiveTeamTab],
    (info) => (info)
);
